
import groupimg from "../../assets/groupimg.png";
import profileimg from "../../assets/profile.png";
import share from "../../assets/share.png";
import greenglobal from "../../assets/images/icons/green-global.png";
import like from "../../assets/images/icons/like.png";
import comment from "../../assets/images/icons/comment.png";
import eye from "../../assets/images/icons/eye.svg";
import eyeslash from "../../assets/images/icons/eye-slash.svg";
import smiley from "../../assets/images/icons/Smiley.svg";
import postone from "../../assets/images/post-1.png";
import posttwo from "../../assets/images/post-2.png";
import postthree from "../../assets/images/post-3.png";
// import video from "../../assets/test.mp4";
const postData = [
  {
    profileimg: profileimg,
    username: "Praven Krishnamoorthy",
    date: "27 Jan 2025, 12:30 PM",
    dob: "24 December 1993",
    location:"Chennai, India",
    country:"Chennai, India",
    mobile:"+91 790 433 0323",
    userid: "@prvnk_sky",
    followers: "300",
    globalIcon: greenglobal,
    content:
      "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque",
    media: [postone, posttwo, postthree],
    likeIcon: like,
    commentIcon: comment,
    viewIcon: eye,
    shareIcon: share,
    smileyIcon: smiley,
    likes: 4.2,
    comments: 150,
    views: 120,
    intro:
    "Loremmmmm ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque",
  
    // New key added for follower images
    followerImages: [
      postone, posttwo, postthree // Add more images if needed
    ]
  }
  
];

export default postData;
